export default __webpack_public_path__ + "static/media/close_black_-1.ef2cec0b.png";